export default {
  orders: [],
  sidebar_opened: false,  
  selectedOrders: {},
}
